module.exports = __webpack_public_path__ + "assets/img/4套利.c43e248f.png";